import React from "react";

import StraightIcon from "@mui/icons-material/Straight";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { ButtonBase, Typography } from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import { OrderByDirection } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";

const THeadTypography = withStyles(Typography, {
  root: {
    fontWeight: 600,
    color: colors.gray,
  },
});

const StyledSwapVertIcon = withStyles(SwapVertIcon, {
  root: {
    height: 24,
    width: 24,
  },
});

const StyledArrowIcon = withStyles(StraightIcon, {
  root: {
    height: 18,
    width: 18,
  },
});

export const useStyles = makeStyles()(() => ({
  icon: {
    color: colors.grayLight,
  },
  sorting: {
    color: colors.grayDark300,
  },
  button: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
}));

type SentFormHeaderProps = {
  type: string;
  title: string;
  handleSort: (type: string, val: OrderByDirection | null) => void;
  sortValue: OrderByDirection | null;
};

const SentFormHeader: React.FC<SentFormHeaderProps> = ({
  title,
  handleSort,
  sortValue,
  type,
}) => {
  const handleIconClick = () => {
    handleSort(type, sortValue);
  };
  const rotationAngle = sortValue == OrderByDirection.Asc ? 0 : 180;
  const transformStyle = `rotate(${rotationAngle}deg)`;
  const { classes } = useStyles();

  return (
    <ButtonBase className={classes.button} onClick={handleIconClick}>
      <THeadTypography variant="body2">{title}</THeadTypography>
      {sortValue == null ? (
        <StyledSwapVertIcon className={classes.icon} />
      ) : (
        <StyledArrowIcon style={{ transform: transformStyle }} />
      )}
    </ButtonBase>
  );
};

export default SentFormHeader;
